/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { educacaoInfantilStyle, diferenciaisStyle } from '../assets/styles/InternasContent.styles'
import { Col, Container, Row } from 'react-bootstrap'
import SliderEstrutura from '@/components/SliderEducacaoInfantil';
import BgEducacaoInfantil from '../assets/images/LP-arabe/bg-educacao-infantil.svg'
import BgEducacaoInfantilM from '../assets/images/LP-arabe/bg-educacao-infantil-m.svg'
import ImgDiferencial1 from '../assets/images/LP-arabe/diferencial-img-1.png'
import ImgDiferencial2 from '../assets/images/LP-arabe/diferencial-img-2.png'

const HeaderContent = () => {
  return (
    <Fragment>
      <section css={educacaoInfantilStyle}>
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <img src={BgEducacaoInfantil} className="d-none d-md-block" alt='Educação que prepara para liderar e prosperar' />
              <img src={BgEducacaoInfantilM} className="d-block d-md-none" alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
          <Row className='title-sec'>
            <Col lg={5} md={5} sm={12}>
              <h1>Educação Infantil</h1>
              <p className='p-bottom'>Foco em desenvolvimento integral e identidade árabe</p>
            </Col>
            <Col lg={7} md={7} sm={12}>
              <p>Na Educação Infantil da Escola Árabe Bertoni, cada criança é acolhida em um ambiente seguro, lúdico e significativo. Nossa proposta pedagógica une o ensino de qualidade ao respeito às tradições islâmicas e à cultura árabe.</p>
            </Col>
          </Row>
        </Container>
      </section>
      <section css={diferenciaisStyle}>
        <Container className='diferencias-sec'>
          <Row data-aos="fade-down" data-aos-delay="500">
            <Col lg={4} md={4} sm={12}>
              <h2>Diferenciais</h2>
              <h3>Educação Infantil</h3>
              <p>A Educação Infantil da Escola Árabe Bertoni é uma experiência única: estrutura integrada à Mesquita Omar Ibn Al-Khatab, ensino do árabe desde cedo, espaços planejados para o brincar e participação ativa das famílias. Tudo isso com a qualidade pedagógica da Rede Bertoni e outros diferenciais:</p>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={7} md={7} sm={12}>
              <img src={ImgDiferencial1} alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
          <Row data-aos="fade-down" data-aos-delay="500" className='row-2'>
            <Col lg={4} md={4} sm={12}>
              <img src={ImgDiferencial2} className="d-none d-md-block" alt='Educação que prepara para liderar e prosperar' />
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={7} md={7} sm={12}>
              <ul>
                <li>- Material e plataforma online COC</li>
                <li>- Desenvolvimento socioemocional </li>
                <li>- Desenvolvimento do gosto pela leitura</li>
                <li>- Alfabetização fonética, desenvolvimento da linguagem, senso matemático e habilidades motoras e artísticas</li>
                <li>- Contato diário com o idioma árabe e ensinamentos islâmicos com atividades que constroem uma base para os conceitos de matemática, ciências e linguagem (inglês e português)</li>
              </ul>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <img src={ImgDiferencial2} className="d-block d-md-none row-2" alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
        </Container>
      </section>
      <SliderEstrutura />
    </Fragment>

  )
}

export default HeaderContent
